export default "__VITE_ASSET__CtTC3bTj__"